<div class="contact-widget">
  <!-- <mat-icon svgIcon="question-answer" class="icon"></mat-icon> -->
  <div><img src="../../../../assets/images/footer-contact.png"/></div>
  <div>
    <p class="title" trans>Do you have any questions about PRO accounts?</p>
    <p class="subtitle" trans>Our support team will be happy to assist you.</p>
    <div class="btn">
      <a
      mat-raised-button
      color="accent"
      target="_blank"
      routerLink="/contact-us"
      trans
      >Contact Us</a
      >
    </div>
  </div>
  <div><img src="../../../../assets/images/footer-contact.png"/></div>
</div>
